import { gql } from "graphql-tag";

const ASSET_LIST_FRAGMENT = gql`
  fragment AssetListFields on AssetObject {
    id
    name
    serial_number
    asset_number
    commissioning_date
    status
    accountId
    asset_model_id
    asset_model {
      id
      name
      assetCategoryId
      assetCategory {
        id
        name
      }
    }
    location_id
    location {
      id
      name
    }
    labelAssignments {
      id
      name
      slug
      color
    }
    createdAt
    updatedAt
  }
`;

export const GET_ASSETS = gql`
  ${ASSET_LIST_FRAGMENT}
  query GetAssets($pagination: PaginationInput, $filter: AssetFilterInput, $sort: AssetSortInput) {
    assets(pagination: $pagination, filter: $filter, sort: $sort) {
      data {
        ...AssetListFields
      }
      meta {
        page
        limit
        total
        totalPages
        hasNext
        hasPrev
      }
    }
  }
`;

/** Same shape as GET_ASSETS.data items; used for export (no pagination). */
export const EXPORT_ASSETS = gql`
  query ExportAssets($filter: AssetFilterInput, $sort: AssetSortInput) {
    exportAssets(filter: $filter, sort: $sort) {
      id
      name
      description
      serial_number
      asset_number
      commissioning_date
      accountId
      asset_category_id
      asset_category {
        id
        name
        description
        sortingOrder
        accountId
      }
      asset_model_id
      asset_model {
        id
        name
        description
        manufacturer
        voltage
        powerKw
        frequencyHz
        current
        protection
        accountId
        assetCategoryId
      }
      location_id
      location {
        id
        name
        categoryId
        accountId
        street
        zip
        city
        country
        phone
      }
      labelAssignments {
        id
        name
        slug
        color
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_ASSET = gql`
  query GetAsset($id: ID!) {
    asset(id: $id) {
      id
      name
      description
      serial_number
      asset_number
      commissioning_date
      status
      accountId
      asset_model_id
      asset_model {
        id
        name
        description
        manufacturer
        voltage
        powerKw
        frequencyHz
        current
        protection
        weight
        dimensions
        energyEfficiencyClass
        standardFieldsVisibility
        accountId
        assetCategoryId
        assetCategory {
          id
          name
        }
        hasActiveTemplates
        count {
          maintenanceTemplates
        }
      }
      location_id
      location {
        id
        name
        categoryId
        accountId
        street
        zip
        city
        country
        phone
      }
      labelAssignments {
        id
        name
        slug
        color
      }
      createdAt
      updatedAt

      holidays {
        id
        name
        startDate
        endDate
        year
        createdAt
        updatedAt
      }
      canFollowUpAppointmentsSaturdays
      canFollowUpAppointmentsSundays
      plannedMaintenancesCount
      plannedInspectionsCount
      documentsCount
      openTicketsCount
      linkedPartsCount
    }
  }
`;
